module.exports = __webpack_public_path__ + "static/media/mockups.9ae6b7f1.png";